import React from 'react';
import { Translate } from '@above-the-treeline/localization';
import './termsOfService.less';

export default function TermsOfService() {
	return (
		<div className="terms-of-service-container">
			<Translate id="by_clicking_sign_up" />{' '}
			<a
				target="_blank"
				rel="noopener noreferrer"
				href="https://www.edelweiss.plus/Terms.aspx">
				<Translate id="terms_of_service" />
			</a>
		</div>
	);
}
